import * as React from 'react';
import { SidebarNext } from './SidebarNextNext';

// FIXME: move to TS, don't reexport SidebarNext
export default SidebarNext;
